const TREATMENT_KEY = "surf.style.avoidRecent.treatment";
const SCENARIO_KEY = "surf.style.avoidRecent.scenario";
const MAX_AVOID = 5;
export function createVariationSeed() {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
function readList(key) {
    if (typeof globalThis.sessionStorage === "undefined")
        return [];
    try {
        const raw = globalThis.sessionStorage.getItem(key);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.map((x) => String(x).trim()).filter(Boolean).slice(0, MAX_AVOID);
    }
    catch {
        return [];
    }
}
function writeList(key, items) {
    if (typeof globalThis.sessionStorage === "undefined")
        return;
    try {
        globalThis.sessionStorage.setItem(key, JSON.stringify(items.slice(0, MAX_AVOID)));
    }
    catch {
        /* ignore quota */
    }
}
export function getAvoidRecentTreatments() {
    return readList(TREATMENT_KEY);
}
export function getAvoidRecentScenarios() {
    return readList(SCENARIO_KEY);
}
export function pushAvoidRecentTreatment(treatment) {
    const trimmed = treatment.trim().slice(0, 240);
    if (!trimmed)
        return;
    const prev = readList(TREATMENT_KEY).filter((t) => t !== trimmed);
    writeList(TREATMENT_KEY, [trimmed, ...prev]);
}
/** Pulse AVOID_RECENT_SCENARIOS — subjectMatter from expander. */
export function pushAvoidRecentScenario(scenario) {
    const trimmed = scenario.trim().slice(0, 120);
    if (!trimmed)
        return;
    const prev = readList(SCENARIO_KEY).filter((t) => t !== trimmed);
    writeList(SCENARIO_KEY, [trimmed, ...prev]);
}
